<template>
  <div class="left-tree">
    <div class="left-tree-title"><span></span><slot></slot></div>
    <el-tree
      ref="tree"
      :data="topicCategorys"
      :props="defaultProps"
      node-key="value"
      :default-expanded-keys="defaultExpandedKeys"
      accordion
      @node-click="handleNodeClick"
      @node-expand="handleExpandClick"
      >
      <span class="custom-tree-node" slot-scope="{ data }">
        <span>{{ data.value }}</span>
        <span class="itemCount">
          {{ data.count }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: 'SearhTree',
  data () {
    return {
      defaultProps: {
        children: 'subdata',
        label: 'value'
      },
      defaultExpandedKeys: [],
      expandNodeName: '',
      currentNodeKey: ''
    }
  },
  props: {
    topicCategorys: Array
  },
  watch: {
    $route: {
      handler: function (val) {
        this._initCheck()
      },
      deep: true
    }
  },
  computed: {
    ...mapState(['filterList'])
  },
  methods: {
    handleExpandClick (data) {
      this.expandNodeName = data.value
      this.defaultExpandedKeys = [data.value]
    },
    // 数组去重
    ArrayFilter (arr) {
      let list = Array.from(new Set(arr))
      return list
    },
    async handleNodeClick(data) {
      if (await this.$loginAuthentication.intercept(0)) {
        if (data.subdata.length > 0) {
          this.$router.replace({ path: 'searchItem', query: { CategoryA: data.value, totalIndex: data.count, query: this.$route.query.query, Province: this.$route.query.Province } })
          if (this.filterList.length > 0) {
            for (var i = 0; i < this.filterList.length; i++) {
              if (this.filterList[i].split(':')[1].split('#')[0] == data.value) {
                localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
                return
              }
            }
          }
          const temp = 'CategoryA:' + data.value
          this.filterList.push(temp)
          localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
        } else {
          const CategoryA = this.expandNodeName
          this.$router.replace({ path: 'searchItem', query: { CategoryA: CategoryA, CategoryB: data.value, totalIndex: this.$route.query.totalIndex, query: this.$route.query.query, Province: this.$route.query.Province } })
          let newArrS = 'CategoryB:' + CategoryA + '#' + data.value
          if (this.filterList.length > 0 && CategoryA) {
            for (var i = 0; i < this.filterList.length; i++) {
              if (this.filterList[i].split(':')[1] == CategoryA) {
                this.filterList.splice(i, 1, newArrS)
                localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
                return
              }
            }
            for (var i = 0; i < this.filterList.length; i++) {
              if (newArrS === this.filterList[i]) {
                return
              }
            }
            this.filterList.push(newArrS)
            localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
          } else if (this.filterList.length <= 0 && CategoryA) {
            for (var i = 0; i < this.filterList.length; i++) {
              if (newArrS === this.filterList[i]) {
                return
              }
            }
            this.filterList.push(newArrS)
            localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
          }
        }
      }
    },
    _initCheck () {
      // debugger
      const CategoryA = this.$route.query.CategoryA
      const Clear = this.$route.query.clear
      if (CategoryA !== undefined) {
        this.defaultExpandedKeys = [CategoryA]
      }
      if (Clear === '1' || Clear === 1) {
        this.defaultExpandedKeys = []
      }
    }
  },
  mounted () {
    this._initCheck()
  }
}
</script>

<style lang="less" scoped>
.left-tree {
  float: left;
  background:#f4f4f4;
  /deep/.is-current {
    .el-tree-node__content {
      .el-tree-node__label {
        color: #1743A5;
        -webkit-text-decoration-line: underline;
        text-decoration-line: underline;
      }
    }
  }
  /deep/.el-tree-node__children {
    .is-current {
      .el-tree-node__content {
        .el-tree-node__label {
          color: #FFFFFF;
          background-color: #4160A5;
          -webkit-text-decoration-line: none;
          text-decoration-line: none;
        }
      }
    }
  }
  .left-tree-title {
    height: 50px;
    border-bottom: 1px solid #DDDDDD;
    line-height: 50px;
    font-size: 16px;
    color: #333333;
    position: relative;
    width: 210px;
    margin: 0 auto;
    text-indent: 30px;
    span {
      &::before {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        left: 0;
        top: 18px;
      }
      &::after {
        content: "";
        position: absolute;
        height: 14px;
        width: 14px;
        background: url("../../assets/imgs/title-bg-top.png") no-repeat;
        top: 23px;
        left: 6px;
      }
    }
  }
  /deep/.el-tree {
    background:#f4f4f4;
    margin-top: 10px;
    .el-tree-node__content {
      box-sizing: border-box;
      width: 220px;
      .custom-tree-node {
        width: 100%;
        .itemCount {
          float: right;
          margin-right: 10px;
          color: #999999;
        }
      }
    }
    .el-tree-node__children {
      box-sizing: border-box;
      .el-tree-node__content {
        width: 220px;
        box-sizing: border-box;
        .custom-tree-node {
          width: 100%;
          .itemCount {
            float: right;
            margin-right: 10px;
            color: #999999;
          }
        }
      }
    }
  }
}
/deep/.is-checked {
  .el-tree-node__content {
    .el-tree-node__label {
      color: #1743A5;
      text-decoration-line: underline;
    }
  }
  .el-tree-node__children {
    .el-tree-node__label {
      color: #606266;
      text-decoration-line: none;
    }
  }
}
/deep/.is-current {
  .el-tree-node__content {
    .expanded  {
      &.el-icon-caret-right {
        &::before {
          content: "\e6d8";
        }
      }
    }
    .el-icon-caret-right {
      &::before {
        content: "\e6d9";
      }
    }
  }
  .el-tree-node__children {
    .el-tree-node__label {
      color: #606266;
      text-decoration-line: none;
    }
  }
}
/deep/.el-tree-node__content {
  width:220px;
  height:32px;
  &:hover {
    background-color: transparent;
    color: #1743a5;
    // text-decoration: underline;
  }
  .expanded  {
    transform: rotate(0deg);
    &.el-icon-caret-right {
      &::before {
        border: 1px solid #bbbbbb;
        content: "\e6d8";
      }
    }
  }
  .el-icon-caret-right {
    &::before {
      border: 1px solid #bbbbbb;
      content: "\e6d9";
    }
  }
}
/deep/.el-tree-node__children {
  .el-tree-node {
    .el-tree-node__expand-icon {
      &.is-leaf {
        &::before {
          content: '·';
          border: none;
          color: #ffffff;
        }
      }
    }
  }
}
/deep/.el-tree-node__children {
  .el-tree-node {
    .el-tree-node__content {
      &:hover {
        background-color: transparent;
        color: #1743a5;
      }
      .el-tree-node__expand-icon {
        &.is-leaf {
          &::before {
            content: '·';
            color: #999999;
          }
        }
      }
    }
  }
}
.left-tree-title {
  height: 50px;
  border-bottom: 1px solid #DDDDDD;
  line-height: 50px;
  font-size: 16px;
  color: #333333;
  position: relative;
  width: 210px;
  margin: 0 auto;
  text-indent: 30px;
  span {
    &::before {
      content: "";
      position: absolute;
      height: 14px;
      width: 14px;
      background: url("../../assets/imgs/title-bg-top.png") no-repeat;
      left: 0;
      top: 18px;
    }
    &::after {
      content: "";
      position: absolute;
      height: 14px;
      width: 14px;
      background: url("../../assets/imgs/title-bg-top.png") no-repeat;
      top: 23px;
      left: 6px;
    }
  }
}
.el-tree {
  background:#f4f4f4;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/treeList/SearhTree.vue